import { useCallback } from "react";
function useOnBlur(props) {
  const {
    selectState: {
      props: { disableClearOnBlur, onBlur },
      searchState: [, setSearchValue]
    }
  } = props;
  return useCallback(
    (event) => {
      if (disableClearOnBlur) {
        onBlur?.(event);
        return;
      }
      setSearchValue("");
      onBlur?.(event);
    },
    [setSearchValue, disableClearOnBlur, onBlur]
  );
}
export {
  useOnBlur
};
//# sourceMappingURL=useOnBlur.js.map
